/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Login_Offline_Activation_Failed_SupportInputs */



/**
* | output |
* | --- |
* | "Activation Failed. Please contact support for more information ({email})" |
*
* @param {Login_Offline_Activation_Failed_SupportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_activation_failed_support = /** @type {((inputs: Login_Offline_Activation_Failed_SupportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Activation_Failed_SupportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Activation echouee. Veuillez contacter le support pour plus d'informations (${i?.email})`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Aktivierung fehlgeschlagen. Bitte kontaktieren Sie den Support für weitere Informationen (${i?.email}).`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Attivazione non riuscita. Contattare l'assistenza per ulteriori informazioni (${i?.email})`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Активация не удалась. Для получения дополнительной информации обратитесь в службу поддержки (${i?.email})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error de activación. Para más información, contacte con el soporte técnico (${i?.email}).`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`激活失败。请联系客服获取更多信息 (${i?.email})`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`アクティベーションに失敗しました。詳細についてはサポートにお問い合わせください (${i?.email})`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`सक्रियण विफल। अधिक जानकारी के लिए कृपया सहायता टीम से संपर्क करें (${i?.email})`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A ativação falhou. Entre em contato com o suporte para obter mais informações (${i?.email})`)
	return /** @type {LocalizedString} */ (`Activation Failed. Please contact support for more information (${i?.email})`)
});